import React from 'react';
import FilePreview from './FilePreview';

/**
 * Backward compatibility wrapper for ImagePreview
 * WHY: Maintains compatibility with existing code that imports ImagePreview
 * 
 * This component now delegates to FilePreview which supports all file types
 * Old prop names (images, onRemove) are mapped to new ones (files, onRemove)
 */
const ImagePreview = ({ images = [], onRemove, error, onClearError }) => {
  return (
    <FilePreview
      files={images}
      onRemove={onRemove}
      error={error}
      onClearError={onClearError}
    />
  );
};

export default ImagePreview;
